<template>
  <div uk-grid class="bjzc-service-list uk-grid-medium uk-child-width-1-2 uk-child-width-1-4@m">
    <div class="" v-for="service in services" :key="service.code" @click="handleClick(service)">
      <div class="bjzc-service-item uk-transition-toggle uk-text-center" tabindex="0">
        <!-- 原来的内容 -->
        <img :src="require(`@/assets/images/service/${service.code}.png`)" alt="" />
        <div class="title">{{ $t(`service.${service.code}`) }}</div>
        <div class="sub-title">{{ $t(`service.${service.code}_en`) }}</div>
        <div class="bjzc-service-item-cover uk-transition-fade uk-position-cover uk-text-center uk-visible@l">
          <span style="">{{ $t(`service.${service.code}`) }}</span>
          <span style="">{{ $t(`service.${service.code}_desc`) }}</span>
          <button class="bjzc-button bjzc-button-plain bjzc-button-small">{{ $t('messages.details') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {
      services: [
        {
          code: 'criminal_case',
          id: 1,
          title: '刑事案件'
        },
        {
          code: 'contract_dispute',
          id: 2,
          title: '合同纠纷'
        },
        {
          code: 'family_affairs',
          id: 3,
          title: '婚姻家事'
        },
        {
          code: 'debt_dispute',
          id: 4,
          title: '债务纠纷'
        },
        {
          code: 'intellectual_property',
          id: 5,
          title: '知识产权'
        },
        {
          code: 'enterprise_legal',
          id: 6,
          title: '企业法律服务'
        },
        {
          code: 'non_litigation',
          id: 7,
          title: '非诉业务'
        },
        {
          code: 'other',
          id: 8,
          title: '其他业务'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.$axios.get('single_pages', { params: { type: 'PageClan::ServicePage' } }).then(res => {
        this.services = res.data

        // messages
        const serviceMessagesZh = {}
        const serviceMessagesEn = {}
        for (const service of this.services) {
          serviceMessagesZh[service.code] = service.title || ''
          if (service.titleEn) serviceMessagesZh[service.code + '_en'] = service.titleEn.toUpperCase() || ''
          serviceMessagesZh[service.code + '_desc'] = service.describe || ''

          if (service.titleEn) serviceMessagesEn[service.code] = service.titleEn.toUpperCase() || ''
          serviceMessagesEn[service.code + '_en'] = ''
          serviceMessagesEn[service.code + '_desc'] = service.describeEn || ''
        }
        this.$i18n.mergeLocaleMessage('zh', {
          service: serviceMessagesZh
        })
        this.$i18n.mergeLocaleMessage('en', {
          service: serviceMessagesEn
        })
      })
    },
    handleClick(service) {
      this.$router.push({
        name: 'ServiceDetail',
        params: {
          id: service.code
        }
      })
    }
  }
}
</script>

<style lang="scss">
/* 业务领域 */
.bjzc-service-list {
  .bjzc-service-item {
    position: relative;
    max-width: 17.5rem;
    height: 12.5rem;
    margin: 0 auto;
    background-color: #f9f9f9;
    border: 1px solid #dcdfe6;
    border-radius: 0.5rem;
    overflow: hidden;
    cursor: pointer;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      height: 3.75rem;
    }

    .title {
      font-size: 1.13rem;
      font-weight: 500;
      margin: 1rem 0 0.25rem;
    }

    .sub-title {
      font-size: 0.88rem;
      color: #ccc;
    }
  }
  .bjzc-service-item-cover {
    background-color: $color-primary;
    color: #fff;

    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 1.25rem;
    & > :nth-child(1) {
      font-size: 1.25em;
    }
    & > :nth-child(2) {
      margin: 10px 0 auto;
      font-weight: 300;
      max-height: 4.75rem;
      display: -webkit-box;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}

@media (max-width: ($screen-width-m - 1)) {
  .bjzc-service-list {
    .bjzc-service-item {
      height: 6rem;
      img {
        height: 2.5rem;
      }

      .title {
        font-size: 0.88rem;
        margin: 0.63rem 0 0;
      }

      .sub-title {
        display: none;
      }
    }
  }
}
</style>
